/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import jwt from '../../http/requests/auth/jwt/index.js'

import axios from '@/axios.js'
import router from '@/router'

export default {

  
  updateUsername ({ commit }, payload) {
    payload.user.updateProfile({
      displayName: payload.displayName
    }).then(() => {

      // If username update is success
      // update in localstorage
      const newUserData = Object.assign({}, payload.user.providerData[0])
      newUserData.displayName = payload.displayName
      commit('UPDATE_USER_INFO', newUserData, {root: true})

      // If reload is required to get fresh data after update
      // Reload current page
      if (payload.isReloadRequired) {
        router.push(router.currentRoute.query.to || '/')
      }
    }).catch((err) => {
      payload.notify({
        time: 8800,
        title: 'Error',
        text: err.message,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger'
      })
    })
  },


  // JWT
  loginJWT ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      jwt.login(payload.userDetails.email, payload.userDetails.password, payload.userDetails.timeZone)
        .then(response => {
          // If there's user data in response
          if (response.data.data) {
            if(response.data.data.firstLogin)
              router.push('/pages/change-password/' + response.data.data.uid )
              // router.push(`/pages/change-password/${response.data.data.uid}` )
           
            else {
            // Set accessToken
            localStorage.setItem('accessToken', response.data.data.token)
            localStorage.setItem('refreshToken', response.data.data.refreshToken)
           
            // Update user details
            commit('UPDATE_USER_INFO', response.data.data, {root: true})

            // Set bearer token in axios
            commit('SET_BEARER', response.data.data.token)
            
            router.push(router.currentRoute.query.to || '/')
            }
            resolve(response);
          } 
          if (response.data && response.data.message && response.data.message.code === 4) {
            reject({
              data: {
                message: {
                  code: 4,
                  type: "error",
                  text: "Your account has been disabled. Please contact your HR Admin at idalumpines@mbsi.com.ph"
                }
              }
            })
          } else {
            // Default fallback for wrong credentials
            reject({
              data: {
                message: {
                  code: 1,
                  type: "error",
                  text: "Wrong Email or Password"
                }
              }
            })
          }
        })
        .catch(error => { reject(error) })
    })
  },
  registerUserJWT ({ commit }, payload) {

    const { displayName, email, password, confirmPassword } = payload.userDetails

    return new Promise((resolve, reject) => {

      // Check confirm password
      if (password !== confirmPassword) {
        reject({message: 'Password doesn\'t match. Please try again.'})
      }

      jwt.registerUser(displayName, email, password)
        .then(response => {
          // Redirect User
          router.push(router.currentRoute.query.to || '/')

          // Update data in localStorage
          localStorage.setItem('accessToken', response.Token)
          commit('UPDATE_USER_INFO', response.data, {root: true})

          resolve(response)
        })
        .catch(error => { reject(error) })
    })
  },
  fetchAccessToken ({commit}) {
    return new Promise((resolve, reject) => {
      jwt.refreshToken()
        .then(response => {
            //  commit('UPDATE_USER_INFO', response.data, {root: true})
            // commit('SET_BEARER', response.data.token)
            resolve(response)
        })
        .catch((error) => {
          reject(error) 
          
        } )
    })
  },
  forgotPassword({commit}, item) {
    return new Promise((resolve, reject) => {
      jwt.forgotPassword(item)
        .then(response => { 
          commit('FORGOT_PASSWORD', response.data.message)
        resolve(response)             
      })
      .catch((error) => {
        reject(error) 
        
      } )
    })
  },
  resetPassword({commit}, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/account/resetpassword', null, {params : {   
          userId : payload.userId, 
          newPassword :  payload.newPassword, 
          code  :  payload.code }})
        .then(response => { 
          //console.log('ERROR SA RESETXXX')
          commit('RESET_PASSWORD', response.data.message)
          resolve(response)  
        })
        .catch((error) => {
          //console.log('ERROR SA RESET')
          // commit('RESET_PASSWORD', error.data.message)
          reject(error)
        })
           
    })
  },
  changePassword({commit}, payload) {
    return new Promise((resolve, reject) => {
      axios.put('/api/account/changepassword', null, {params : {   
          userId : payload.userId, 
          currentPassword: payload.currentPassword,
          newPassword :  payload.newPassword,}})
        .then(response => { 
          //console.log('ERROR SA RESETXXX')
          commit('CHANGE_PASSWORD', response.data.message)
          resolve(response)  
        })
        .catch((error) => {
          //console.log('ERROR SA RESET')
          // commit('RESET_PASSWORD', error.data.message)
          reject(error)
        })
           
    })
  },
  confirmAccount({commit}, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/api/account/confirm', { params : {   
          userId : payload.userId, 
          code  :  payload.code }})
        .then(response => { 
          commit('CONFIRM_ACCOUNT', response)
          resolve(response)  
        })
        .catch((error) => {
          // commit('RESET_PASSWORD', error.data.message)
          reject(error)
        })
           
    })
  }
 
}
